import './index.sass'
import './burger-styles.sass'
import {observer} from "mobx-react";
import StoreContext from "../../store/RootStore";
import {useEffect, useMemo} from "react";
import LoginHandler from "../../functions/login";

function Header() {
    const {AccountStore} = StoreContext();
    const loginHandler = useMemo(() => new LoginHandler(), []);


    useEffect(() => {
        if(AccountStore.accountAddress)
            {
                 loginHandler.getUserBalancetkn();
                 loginHandler.getUserBalancewax();
    }
    if(AccountStore.avatarData.length === 0)
    {
        loginHandler.getAvConfig();
    }
    }, [AccountStore.accountAddress, AccountStore.avatarData.length, loginHandler])

    return (
<div className="head">
    <div className="token">
        <div id="dov-x"><p>{parseFloat(AccountStore.getBlcData().dovx).toFixed(2)}</p></div>
        <div id="dov-f"><p>{parseFloat(AccountStore.getBlcData().dovf).toFixed(2)}</p></div>
        <div id="dov-h"><p>{parseFloat(AccountStore.getBlcData().dovh).toFixed(2)}</p></div>
        <div id="dov-s"><p>{parseFloat(AccountStore.getBlcData().dovs).toFixed(2)}</p></div>
        <div id="dov-r"><p>{parseFloat(AccountStore.getBlcData().dovr).toFixed(2)}</p></div>
    </div>
</div>
    )
}

export default observer(Header);